import { personActions } from "./person";

export const person_actions = {
  ...personActions,
};
export { default as personSlices } from "./person";
